module.exports = (__webpack_require__(60784))(9835);